module.exports = __webpack_public_path__ + "img/poc_sketch.a83db457.png";